/* eslint-disable max-len */
import React from 'react';

const PauseBlack: React.FC<object> = () => {

    return  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="12" fill="#A7B4B4"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM7.05887 17.2937C7.05887 18.2684 7.84896 19.0585 8.82358 19.0585C9.7982 19.0585 10.5883 18.2684 10.5883 17.2937V6.70551C10.5883 5.73089 9.7982 4.94081 8.82358 4.94081C7.84896 4.94081 7.05887 5.73089 7.05887 6.70551V17.2937ZM15.1768 19.0585C14.2022 19.0585 13.4121 18.2684 13.4121 17.2937V6.70551C13.4121 5.73089 14.2022 4.94081 15.1768 4.94081C16.1514 4.94081 16.9415 5.73089 16.9415 6.70551V17.2937C16.9415 18.2684 16.1514 19.0585 15.1768 19.0585Z" fill="white"/>
    </svg>;
};

export default PauseBlack;